import React, { useMemo } from 'react';
import { FormBlock } from 'Components/Admin/Form';
import fieldsManager from 'Components/Admin/Form/utils/fieldsManager';

const useRenderFormFields = (formItems = [], isBlocks) => {
  return useMemo(() => {
    return isBlocks
      ? formItems.map((block, index) => (
        <FormBlock className={block.className} key={index} title={block.title} subTitle={block.subTitle}>
          {block.items.map(fieldsManager)}
        </FormBlock>
      ))
      : <FormBlock>{formItems.map(fieldsManager)}</FormBlock>;
  }, [formItems, isBlocks]);
};

export default useRenderFormFields;
